import React from 'react';
import { Dialog, DialogContent } from './ui/dialog';
import { Button } from './ui/button';
import { X, CheckCircle2 } from 'lucide-react';

const ExitIntentPopup = ({ isOpen, onClose, onOpenForm }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md p-0 overflow-hidden bg-white border-slate-200 rounded-2xl">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-50 w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center transition-colors"
        >
          <X className="w-4 h-4 text-slate-600" />
        </button>

        <div className="p-8">
          <div className="text-center mb-6">
            <h3 className="text-xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Outfit' }}>
              Prima di andare...
            </h3>
            <p className="text-slate-600 text-sm">
              Hai problemi con il tuo tetto? Possiamo aiutarti.
            </p>
          </div>

          <div className="space-y-3 mb-6">
            <div className="flex items-center gap-3">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 flex-shrink-0" />
              <span className="text-slate-700 text-sm">Sopralluogo gratuito e senza impegno</span>
            </div>
            <div className="flex items-center gap-3">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 flex-shrink-0" />
              <span className="text-slate-700 text-sm">Preventivo dettagliato entro 24 ore</span>
            </div>
            <div className="flex items-center gap-3">
              <CheckCircle2 className="w-4 h-4 text-emerald-500 flex-shrink-0" />
              <span className="text-slate-700 text-sm">Risparmia fino al 70% senza ponteggi</span>
            </div>
          </div>

          <div className="space-y-3">
            <Button
              onClick={onOpenForm}
              data-testid="exit-intent-cta"
              size="lg"
              className="w-full bg-[#FF5722] hover:bg-[#FF7043] text-white font-bold h-12 rounded-full"
            >
              Richiedi Sopralluogo Gratuito
            </Button>
            <Button
              onClick={onClose}
              variant="ghost"
              className="w-full text-slate-500 hover:text-slate-700 text-sm font-normal"
            >
              No grazie, magari piu tardi
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ExitIntentPopup;
